export class LoginBySessionModel{
    sessionId: string;
    verificationCode: string;
    status: LoginBySessionStatus;
}

export enum LoginBySessionStatus{
    SendVerification = 1,
    CheckVerification = 2
}